/**
 * Iniciais do Portrait (§3.8, FE §3.15): até duas palavras de `display_name` com mais de 2 letras, ignorando títulos e
 * tratamentos; primeira letra de cada, maiúscula. "Dr. Fulano de Tal" → "FT"; "Ana Lu" → "A".
 */

/** Títulos e tratamentos ignorados (§3.8). Comparação sem caixa, sem acento e sem o ponto final. */
export const IGNORED_TITLES: readonly string[] = [
  'dr.',
  'dra.',
  'pastor',
  'pastora',
  'coronel',
  'delegado',
  'delegada',
  'professor',
  'professora',
  'capitão',
  'general',
  'sargento',
  'irmão',
  'irmã',
];

const fold = (word: string) =>
  word.normalize('NFD').replace(/\p{M}/gu, '').toLocaleLowerCase('pt-BR').replace(/\.+$/, '');

const TITLES = new Set(IGNORED_TITLES.map(fold));
const LETTER = /\p{L}/gu;

const letters = (word: string) => word.match(LETTER) ?? [];
const firstLetter = (word: string) => (letters(word)[0] ?? '').toLocaleUpperCase('pt-BR');

/** Iniciais (0 a 2 letras maiúsculas). Sem palavra com mais de 2 letras, cai na 1ª letra da 1ª palavra que não é título. */
export function initials(displayName: string): string {
  const words = displayName.split(/\s+/).filter((w) => letters(w).length > 0 && !TITLES.has(fold(w)));
  const long = words.filter((w) => letters(w).length > 2).slice(0, 2);
  if (long.length > 0) return long.map(firstLetter).join('');
  return words[0] ? firstLetter(words[0]) : '';
}
